export default function DeleteButton() {
    return (
        <i  className="icon delete_icon" />
    )
}